var GQLVariable;
((GQLVariable2) => {
  GQLVariable2.Json = { graphQlType: "Json", required: false };
  GQLVariable2.String = { graphQlType: "String", required: false };
  GQLVariable2.Int = { graphQlType: "Int", required: false };
  GQLVariable2.Required = (type) => ({
    graphQlType: type.graphQlType + "!",
    required: true
  });
  GQLVariable2.List = (type) => ({
    graphQlType: `[${type.graphQlType}!]`,
    required: false
  });
  GQLVariable2.Enum = (name) => ({
    graphQlType: name,
    required: false
  });
})(GQLVariable || (GQLVariable = {}));
export {
  GQLVariable
};
//# sourceMappingURL=variables.js.map
